<template>
  <div>
    <!-- <v-btn v-if="$vuetify.breakpoint.smAndDown" small color="#00acc2" @click="openDialog()" fab>
      <v-icon color="#fff" medium>contact_mail</v-icon>
    </v-btn> -->
    <!-- // Usado o v-list-tile pois é usado no menu do botão que fica no top de ajuda ao usuário-->
    <!-- <v-list-tile v-else @click="openDialog()">
      <v-icon>contact_mail</v-icon>
      <span>Treinamento Grátis</span>       
    </v-list-tile> -->
    <v-dialog persistent v-model="dialog" scrollable max-width="500">
      <v-card>
        <v-card-title primary-title>
          <span v-if="requested" class="title">Obrigado pela solicitação! Entraremos em contato!</span>
          <span v-else class="title">Solicite um treinamento com nossos consultores</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="!requested" justify-center>
          <v-form ref="form" @keyup.native.esc="cancel(400)" @keyup.native.ctrl.enter="confirm()">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <span>Como prefere manter o contato?</span>
                </v-flex>
                  <v-radio-group v-model="editedItem.type" row>
                    <v-radio
                      label="Email"
                      value="email"
                    ></v-radio>
                    <v-radio
                      label="Telefone"
                      value="phone"
                    ></v-radio>
                  </v-radio-group>
                <v-flex xs12 v-show="editedItem.type === 'email'">
                  <v-text-field maxlength="190" counter="190" label="email"
                                v-model="editedItem.email" :rules="emailRule('email', false, false)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-show="editedItem.type === 'phone'">
                  <v-text-field label="Telefone"
                                mask='(##) #####-####'
                                v-model="editedItem.phone"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if='!requested' class="mx-0" color="primary darken-2" @click.native="confirm">Confirmar</v-btn>
          <v-btn class="mx-0" @click.native="cancel">{{this.requested ? 'Sair' : 'Cancelar'}}</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import rules from './../../mixin/rules'
  
  export default {
    name: 'PFreeTraining',
    mixins: [rules],
    data () {
      return {
        requested: false,
        dialog: false,
        editedItem: {email: '', phone: '', type: 'email'}
      }
    },
    mounted () {
      this.editedItem.email = this.$auth.user().email
      this.editedItem.phone = this.$auth.user().phone
    },
    methods: {
      openDialog () {
        this.dialog = true
      },
      confirm () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post('api/request_training', this.editedItem).then((res) => {
          this.requested = true
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Solicitação enviada com sucesso! Entraremos em contato!',
            color: 'success',
            dialog: true
          })
        },
        err => {
          console.log('res', err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível enviar a solicitação, reporte o erro.',
            color: 'error',
            dialog: true
          })
        })
      },
      cancel () {
        this.dialog = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PFreeTraining.vue